/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisableBusinessBody
 */
export interface DisableBusinessBody {
    /**
     * 
     * @type {string}
     * @memberof DisableBusinessBody
     */
    disableReason: string;
}

/**
 * Check if a given object implements the DisableBusinessBody interface.
 */
export function instanceOfDisableBusinessBody(value: object): value is DisableBusinessBody {
    if (!('disableReason' in value) || value['disableReason'] === undefined) return false;
    return true;
}

export function DisableBusinessBodyFromJSON(json: any): DisableBusinessBody {
    return DisableBusinessBodyFromJSONTyped(json, false);
}

export function DisableBusinessBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisableBusinessBody {
    if (json == null) {
        return json;
    }
    return {
        
        'disableReason': json['disableReason'],
    };
}

export function DisableBusinessBodyToJSON(json: any): DisableBusinessBody {
    return DisableBusinessBodyToJSONTyped(json, false);
}

export function DisableBusinessBodyToJSONTyped(value?: DisableBusinessBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'disableReason': value['disableReason'],
    };
}

